import React from "react";
import {
    Box,
    Container,
    Grid,
    Card,
    Typography,
} from "@mui/material";

import alumi1 from "../img/01_ANVESH.mp4";
import alumi2 from "../img/02_KRISHNA KUMAR.mp4";
import alumi3 from "../img/02_SAJEEV.mp4";
import alumi4 from "../img/04_KUPPALA BHARGAVA_V3.mp4";

const alumniVideos = [
    { id: 1, video: alumi1 },
    { id: 2, video: alumi2 },
    { id: 3, video: alumi3 },
    { id: 4, video: alumi4 },
];

const AlumniVideoSection = () => {
    return (
        <Box
            sx={{
                py: 2,
                backgroundColor: "blue",
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    maxWidth: "1400px",
                    mx: "auto",
                }}
            >
                {/* Heading */}
                <Box
                    textAlign="center"
                    mb={4}
                    sx={{
                        pt: 1, // top padding kam
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: {
                                xs: "28px",
                                md: "35px",
                            },
                            fontWeight: 800,
                            lineHeight: 1.2,
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                color: "#ff6b00",
                            }}
                        >
                            Success Stories
                        </Box>{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "white",
                            }}
                        >
                            of Our Alumni
                        </Box>
                    </Typography>
                </Box>

                {/* Videos */}
                <Grid container spacing={4}>
                    {alumniVideos.map((item) => (
                        <Grid item xs={12} sm={6} md={3} key={item.id}>
                            <Card
                                sx={{
                                    borderRadius: "20px",
                                    overflow: "hidden",
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-8px)",
                                        boxShadow: "0 15px 40px rgba(0,0,0,0.18)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: {
                                            xs: 450,
                                            sm: 500,
                                            md: 550,
                                        },
                                        backgroundColor: "#000",
                                    }}
                                >
                                    <video
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    >
                                        <source src={item.video} type="video/mp4" />
                                    </video>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default AlumniVideoSection;